class VideoControls extends window.HTMLElement {
  isPlaying = false
  videos = []

  togglePlay() {
    this.videos.forEach((video) => {
      if (this.isPlaying) {
        video.pause()
      } else {
        video.play()
      }
    })
  }

  // to be overridden
  onPlay() {}

  disconnectedCallback() {
    this.videos = this.dataset.target
      ? document.querySelectorAll(`#${this.dataset.target} video`)
      : this.parentElement.querySelectorAll('video')

    this.querySelector('button').removeEventListener(
      'click',
      this.togglePlay.bind(this)
    )

    this.videos.forEach((video) => {
      video.removeEventListener('play', () => {
        this.isPlaying = true
        this.classList.add('is-playing')
        this.onPlay()
      })
      video.removeEventListener('pause', () => {
        this.isPlaying = false
        this.classList.remove('is-playing')
      })
    })
  }

  connectedCallback() {
    this.videos = this.dataset.target
      ? document.querySelectorAll(`#${this.dataset.target} video`)
      : this.parentElement.querySelectorAll('video')

    this.querySelector('button').addEventListener(
      'click',
      this.togglePlay.bind(this)
    )

    this.videos.forEach((video) => {
      if (video.paused) {
        this.isPlaying = false
        this.classList.remove('is-playing')
      }

      if (!video.paused) {
        this.isPlaying = true
        this.classList.add('is-playing')
        this.onPlay()
      }

      video.addEventListener('play', () => {
        this.isPlaying = true
        this.classList.add('is-playing')
        this.onPlay()
      })
      video.addEventListener('pause', () => {
        this.isPlaying = false
        this.classList.remove('is-playing')
      })

      // if video is playing, pause it when the user clicks outside the video

      this.addEventListener('click', (event) => {
        if (!video.contains(event.target)) {
          this.togglePlay()
        }
      })
    })
  }
}

window.customElements.define('video-controls', VideoControls)

export default VideoControls
